import {
  KProperty02ce7r476m8633 as KProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { DecimalFraction15n0off36xuu9 as DecimalFraction } from '../internal/math.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from '../Exceptions.mjs';
import { requireParsedField387b2jr94jy2p as requireParsedField } from './YearMonthFormat.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from '../LocalTime.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { padStart36w1507hs626a as padStart } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  hour$default3ltjmfc740vqh as hour$default,
  minute$defaultsgib3pp3rn60 as minute$default,
  second$defaultabrspkhk2hrb as second$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithTime2lgb7k6hqa1zi as WithTime,
  char1r4ssccmdfesy as char,
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  optional3j6ywsx1pxeh6 as optional,
} from './DateTimeFormatBuilder.mjs';
import {
  AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat,
  Padding_ZERO_getInstance165tawgk9tdj7 as Padding_ZERO_getInstance,
  Padding_SPACE_getInstance3jytkjkv2jvr6 as Padding_SPACE_getInstance,
} from './DateTimeFormat.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { BasicFormatStructure1rp1tyv3u2fjw as BasicFormatStructure } from '../internal/format/FormatStructure.mjs';
import {
  UnsignedIntFieldFormatDirective20kfpdbszyixg as UnsignedIntFieldFormatDirective,
  DecimalFractionFieldFormatDirective1h9sbm886izzq as DecimalFractionFieldFormatDirective,
} from '../internal/format/FieldFormatDirective.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  PropertyAccessor1m9zk65ebkfc4 as PropertyAccessor,
  UnsignedFieldSpec1pqzij1hidkca as UnsignedFieldSpec,
  GenericFieldSpecnllvuuqbuxsd as GenericFieldSpec,
} from '../internal/format/FieldSpec.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_ISO_TIME() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  var tmp0 = ISO_TIME$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_TIME', 0, tmp, _get_ISO_TIME_$ref_kyx2od(), null);
  return tmp0.get_value_j01efc_k$();
}
var ISO_TIME$delegate;
function get_emptyIncompleteLocalTime() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  return emptyIncompleteLocalTime;
}
var emptyIncompleteLocalTime;
function set_fractionOfSecond(value) {
  this.set_nanosecond_xpjfxy_k$(value == null ? null : value.fractionalPartWithNDigits_sivm3u_k$(9));
}
function get_fractionOfSecond() {
  var tmp0_safe_receiver = this.get_nanosecond_fws9td_k$();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new (DecimalFraction())(tmp0_safe_receiver, 9);
  }
  return tmp;
}
var TimeFieldContainerClass;
function TimeFieldContainer() {
  if (TimeFieldContainerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'TimeFieldContainer');
    TimeFieldContainerClass = $;
  }
  return TimeFieldContainerClass;
}
var IncompleteLocalTimeClass;
function IncompleteLocalTime() {
  if (IncompleteLocalTimeClass === VOID) {
    class $ {
      constructor(hour, hourOfAmPm, amPm, minute, second, nanosecond) {
        hour = hour === VOID ? null : hour;
        hourOfAmPm = hourOfAmPm === VOID ? null : hourOfAmPm;
        amPm = amPm === VOID ? null : amPm;
        minute = minute === VOID ? null : minute;
        second = second === VOID ? null : second;
        nanosecond = nanosecond === VOID ? null : nanosecond;
        this.hour_1 = hour;
        this.hourOfAmPm_1 = hourOfAmPm;
        this.amPm_1 = amPm;
        this.minute_1 = minute;
        this.second_1 = second;
        this.nanosecond_1 = nanosecond;
      }
      set_hour_cn99tm_k$(_set____db54di) {
        this.hour_1 = _set____db54di;
      }
      get_hour_wonfal_k$() {
        return this.hour_1;
      }
      set_hourOfAmPm_4kn0va_k$(_set____db54di) {
        this.hourOfAmPm_1 = _set____db54di;
      }
      get_hourOfAmPm_c9obsj_k$() {
        return this.hourOfAmPm_1;
      }
      set_amPm_20li4z_k$(_set____db54di) {
        this.amPm_1 = _set____db54di;
      }
      get_amPm_woiw0i_k$() {
        return this.amPm_1;
      }
      set_minute_35xlhm_k$(_set____db54di) {
        this.minute_1 = _set____db54di;
      }
      get_minute_gnc10d_k$() {
        return this.minute_1;
      }
      set_second_5q0zme_k$(_set____db54di) {
        this.second_1 = _set____db54di;
      }
      get_second_jf7fjx_k$() {
        return this.second_1;
      }
      set_nanosecond_xpjfxy_k$(_set____db54di) {
        this.nanosecond_1 = _set____db54di;
      }
      get_nanosecond_fws9td_k$() {
        return this.nanosecond_1;
      }
      toLocalTime_u7y1k3_k$() {
        var tmp0_safe_receiver = this.hour_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = this.hourOfAmPm_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.require' call
            if (!((((tmp0_safe_receiver + 11 | 0) % 12 | 0) + 1 | 0) === tmp0_safe_receiver_0)) {
              var message = 'Inconsistent hour and hour-of-am-pm: hour is ' + tmp0_safe_receiver + ', but hour-of-am-pm is ' + tmp0_safe_receiver_0;
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
            }
          }
          var tmp1_safe_receiver = this.amPm_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.require' call
            if (!(tmp1_safe_receiver.equals(AmPmMarker_PM_getInstance()) === tmp0_safe_receiver >= 12)) {
              var message_0 = 'Inconsistent hour and the AM/PM marker: hour is ' + tmp0_safe_receiver + ', but the AM/PM marker is ' + tmp1_safe_receiver.toString();
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
            }
          }
          tmp = tmp0_safe_receiver;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          var tmp2_safe_receiver = this.hourOfAmPm_1;
          var tmp_1;
          if (tmp2_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_1 = this.amPm_1;
            var tmp_2;
            if (tmp0_safe_receiver_1 == null) {
              tmp_2 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.let' call
              tmp_2 = (tmp2_safe_receiver === 12 ? 0 : tmp2_safe_receiver) + (tmp0_safe_receiver_1.equals(AmPmMarker_PM_getInstance()) ? 12 : 0) | 0;
            }
            tmp_1 = tmp_2;
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        var tmp3_elvis_lhs = tmp_0;
        var tmp_3;
        if (tmp3_elvis_lhs == null) {
          throw DateTimeFormatException().new_kotlinx_datetime_DateTimeFormatException_hir7ye_k$('Incomplete time: missing hour');
        } else {
          tmp_3 = tmp3_elvis_lhs;
        }
        var hour = tmp_3;
        var tmp_4 = requireParsedField(this.minute_1, 'minute');
        var tmp4_elvis_lhs = this.second_1;
        var tmp_5 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        var tmp5_elvis_lhs = this.nanosecond_1;
        return LocalTime().new_kotlinx_datetime_LocalTime_huq53_k$(hour, tmp_4, tmp_5, tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs);
      }
      populateFrom_auih6d_k$(localTime) {
        this.hour_1 = localTime.hour_1;
        this.hourOfAmPm_1 = ((localTime.hour_1 + 11 | 0) % 12 | 0) + 1 | 0;
        this.amPm_1 = localTime.hour_1 >= 12 ? AmPmMarker_PM_getInstance() : AmPmMarker_AM_getInstance();
        this.minute_1 = localTime.minute_1;
        this.second_1 = localTime.second_1;
        this.nanosecond_1 = localTime.nanosecond_1;
      }
      copy_1tks5_k$() {
        return new (IncompleteLocalTime())(this.hour_1, this.hourOfAmPm_1, this.amPm_1, this.minute_1, this.second_1, this.nanosecond_1);
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        var tmp_3;
        var tmp_4;
        if (other instanceof IncompleteLocalTime()) {
          tmp_4 = this.hour_1 == other.hour_1;
        } else {
          tmp_4 = false;
        }
        if (tmp_4) {
          tmp_3 = this.hourOfAmPm_1 == other.hourOfAmPm_1;
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp_2 = equals(this.amPm_1, other.amPm_1);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.minute_1 == other.minute_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.second_1 == other.second_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.nanosecond_1 == other.nanosecond_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        var tmp0_elvis_lhs = this.hour_1;
        var tmp = imul(tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, 31);
        var tmp1_elvis_lhs = this.hourOfAmPm_1;
        var tmp_0 = tmp + imul(tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs, 31) | 0;
        var tmp2_safe_receiver = this.amPm_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
        var tmp_1 = tmp_0 + imul(tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs, 31) | 0;
        var tmp4_elvis_lhs = this.minute_1;
        var tmp_2 = tmp_1 + imul(tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs, 31) | 0;
        var tmp5_elvis_lhs = this.second_1;
        var tmp_3 = tmp_2 + imul(tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs, 31) | 0;
        var tmp6_elvis_lhs = this.nanosecond_1;
        return tmp_3 + (tmp6_elvis_lhs == null ? 0 : tmp6_elvis_lhs) | 0;
      }
      toString() {
        var tmp0_elvis_lhs = this.hour_1;
        var tmp = toString(tmp0_elvis_lhs == null ? '??' : tmp0_elvis_lhs);
        var tmp1_elvis_lhs = this.minute_1;
        var tmp_0 = toString(tmp1_elvis_lhs == null ? '??' : tmp1_elvis_lhs);
        var tmp2_elvis_lhs = this.second_1;
        var tmp_1 = toString(tmp2_elvis_lhs == null ? '??' : tmp2_elvis_lhs);
        var tmp3_safe_receiver = this.nanosecond_1;
        var tmp_2;
        if (tmp3_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var it = tmp3_safe_receiver.toString();
          tmp_2 = padStart(it, 9 - it.length | 0, _Char___init__impl__6a9atx(48));
        }
        var tmp4_elvis_lhs = tmp_2;
        return tmp + ':' + tmp_0 + ':' + tmp_1 + '.' + (tmp4_elvis_lhs == null ? '???' : tmp4_elvis_lhs);
      }
    }
    protoOf($).set_fractionOfSecond_45hz7f_k$ = set_fractionOfSecond;
    protoOf($).get_fractionOfSecond_3ubmju_k$ = get_fractionOfSecond;
    initMetadataForClass($, 'IncompleteLocalTime', IncompleteLocalTime, VOID, [TimeFieldContainer()]);
    IncompleteLocalTimeClass = $;
  }
  return IncompleteLocalTimeClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  AmPmMarker_AM_instance = new (AmPmMarker())('AM', 0);
  AmPmMarker_PM_instance = new (AmPmMarker())('PM', 1);
}
var AmPmMarker_AM_instance;
var AmPmMarker_PM_instance;
var AmPmMarkerClass;
function AmPmMarker() {
  if (AmPmMarkerClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'AmPmMarker');
    AmPmMarkerClass = $;
  }
  return AmPmMarkerClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      build_agwrib_k$(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (LocalTimeFormat())(builder.build_1k0s4u_k$());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.actualBuilder_1 = actualBuilder;
      }
      get_actualBuilder_7qypdo_k$() {
        return this.actualBuilder_1;
      }
      addFormatStructureForTime_h3r7lv_k$(structure) {
        this.actualBuilder_1.add_b6pdwl_k$(structure);
      }
      createEmpty_8k9z67_k$() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).appendAlternativeParsingImpl_9hljk3_k$ = appendAlternativeParsingImpl;
    protoOf($).appendOptionalImpl_725ywl_k$ = appendOptionalImpl;
    protoOf($).chars_pe6iqb_k$ = chars;
    protoOf($).build_1k0s4u_k$ = build;
    protoOf($).hour_cqw3y8_k$ = hour;
    protoOf($).hour$default_ke0z0o_k$ = hour$default;
    protoOf($).minute_p09m40_k$ = minute;
    protoOf($).minute$default_r7oarc_k$ = minute$default;
    protoOf($).second_rj6d1s_k$ = second;
    protoOf($).second$default_ix75t4_k$ = second$default;
    protoOf($).secondFraction_6m5e86_k$ = secondFraction;
    protoOf($).time_eev9o3_k$ = time;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithTimeBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocalTimeFormatClass;
function LocalTimeFormat() {
  if (LocalTimeFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.actualFormat_1 = actualFormat;
      }
      get_actualFormat_d0ha3y_k$() {
        return this.actualFormat_1;
      }
      intermediateFromValue_rmnujv_k$(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteLocalTime())();
        this_0.populateFrom_auih6d_k$(value);
        return this_0;
      }
      intermediateFromValue_816pep_k$(value) {
        return this.intermediateFromValue_rmnujv_k$(value instanceof LocalTime() ? value : THROW_CCE());
      }
      valueFromIntermediate_icz3rz_k$(intermediate) {
        return intermediate.toLocalTime_u7y1k3_k$();
      }
      valueFromIntermediate_60ox3m_k$(intermediate) {
        return this.valueFromIntermediate_icz3rz_k$(intermediate instanceof IncompleteLocalTime() ? intermediate : THROW_CCE());
      }
      get_emptyIntermediate_lysuyr_k$() {
        return get_emptyIncompleteLocalTime();
      }
    }
    initMetadataForClass($, 'LocalTimeFormat');
    LocalTimeFormatClass = $;
  }
  return LocalTimeFormatClass;
}
function hour(padding) {
  return this.addFormatStructureForTime_h3r7lv_k$(new (BasicFormatStructure())(new (HourDirective())(padding)));
}
function minute(padding) {
  return this.addFormatStructureForTime_h3r7lv_k$(new (BasicFormatStructure())(new (MinuteDirective())(padding)));
}
function second(padding) {
  return this.addFormatStructureForTime_h3r7lv_k$(new (BasicFormatStructure())(new (SecondDirective())(padding)));
}
function secondFraction(minLength, maxLength) {
  return this.addFormatStructureForTime_h3r7lv_k$(new (BasicFormatStructure())(new (FractionalSecondDirective())(minLength, maxLength)));
}
function time(format) {
  return this.addFormatStructureForTime_h3r7lv_k$((format instanceof LocalTimeFormat() ? format : THROW_CCE()).actualFormat_1);
}
var AbstractWithTimeBuilderClass;
function AbstractWithTimeBuilder() {
  if (AbstractWithTimeBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithTimeBuilder', VOID, VOID, [WithTime()]);
    AbstractWithTimeBuilderClass = $;
  }
  return AbstractWithTimeBuilderClass;
}
var HourDirectiveClass;
function HourDirective() {
  if (HourDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = TimeFields_getInstance().hour_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof HourDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'HourDirective');
    HourDirectiveClass = $;
  }
  return HourDirectiveClass;
}
var MinuteDirectiveClass;
function MinuteDirective() {
  if (MinuteDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = TimeFields_getInstance().minute_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof MinuteDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'MinuteDirective');
    MinuteDirectiveClass = $;
  }
  return MinuteDirectiveClass;
}
var SecondDirectiveClass;
function SecondDirective() {
  if (SecondDirectiveClass === VOID) {
    class $ extends UnsignedIntFieldFormatDirective() {
      constructor(padding) {
        var tmp = TimeFields_getInstance().second_1;
        // Inline function 'kotlinx.datetime.format.minDigits' call
        var tmp_0 = padding.equals(Padding_ZERO_getInstance()) ? 2 : 1;
        // Inline function 'kotlinx.datetime.format.spaces' call
        super(tmp, tmp_0, padding.equals(Padding_SPACE_getInstance()) ? 2 : null);
        this.padding_1 = padding;
      }
      equals(other) {
        var tmp;
        if (other instanceof SecondDirective()) {
          tmp = this.padding_1.equals(other.padding_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.padding_1.hashCode();
      }
    }
    initMetadataForClass($, 'SecondDirective');
    SecondDirectiveClass = $;
  }
  return SecondDirectiveClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.NO_EXTRA_ZEROS_1 = listOf([0, 0, 0, 0, 0, 0, 0, 0, 0]);
        this.GROUP_BY_THREE_1 = listOf([2, 1, 0, 2, 1, 0, 2, 1, 0]);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var FractionalSecondDirectiveClass;
function FractionalSecondDirective() {
  if (FractionalSecondDirectiveClass === VOID) {
    class $ extends DecimalFractionFieldFormatDirective() {
      constructor(minDigits, maxDigits, zerosToAdd) {
        Companion_getInstance_0();
        zerosToAdd = zerosToAdd === VOID ? Companion_getInstance_0().NO_EXTRA_ZEROS_1 : zerosToAdd;
        super(TimeFields_getInstance().fractionOfSecond_1, minDigits, maxDigits, zerosToAdd);
        this.minDigits_2 = minDigits;
        this.maxDigits_2 = maxDigits;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof FractionalSecondDirective()) {
          tmp_0 = this.minDigits_2 === other.minDigits_2;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = this.maxDigits_2 === other.maxDigits_2;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(31, this.minDigits_2) + this.maxDigits_2 | 0;
      }
    }
    initMetadataForClass($, 'FractionalSecondDirective');
    FractionalSecondDirectiveClass = $;
  }
  return FractionalSecondDirectiveClass;
}
function TimeFieldContainer$_get_hour_$ref_8ezbwm() {
  return constructCallableReference((p0) => p0.get_hour_wonfal_k$(), 1, 0, 32);
}
function TimeFieldContainer$_set_hour_$ref_l7vnde() {
  return constructCallableReference((p0, p1) => {
    p0.set_hour_cn99tm_k$(p1);
    return Unit_instance;
  }, 2, 0, 33);
}
function TimeFieldContainer$_get_minute_$ref_evb2i2() {
  return constructCallableReference((p0) => p0.get_minute_gnc10d_k$(), 1, 0, 34);
}
function TimeFieldContainer$_set_minute_$ref_6xin6() {
  return constructCallableReference((p0, p1) => {
    p0.set_minute_35xlhm_k$(p1);
    return Unit_instance;
  }, 2, 0, 35);
}
function TimeFieldContainer$_get_second_$ref_t7tjxy() {
  return constructCallableReference((p0) => p0.get_second_jf7fjx_k$(), 1, 0, 36);
}
function TimeFieldContainer$_set_second_$ref_qr1wvy() {
  return constructCallableReference((p0, p1) => {
    p0.set_second_5q0zme_k$(p1);
    return Unit_instance;
  }, 2, 0, 37);
}
function TimeFieldContainer$_get_fractionOfSecond_$ref_u85by5() {
  return constructCallableReference((p0) => p0.get_fractionOfSecond_3ubmju_k$(), 1, 0, 38);
}
function TimeFieldContainer$_set_fractionOfSecond_$ref_quw20n() {
  return constructCallableReference((p0, p1) => {
    p0.set_fractionOfSecond_45hz7f_k$(p1);
    return Unit_instance;
  }, 2, 0, 39);
}
function TimeFieldContainer$_get_amPm_$ref_u9tt1b() {
  return constructCallableReference((p0) => p0.get_amPm_woiw0i_k$(), 1, 0, 40);
}
function TimeFieldContainer$_set_amPm_$ref_hgxhkj() {
  return constructCallableReference((p0, p1) => {
    p0.set_amPm_20li4z_k$(p1);
    return Unit_instance;
  }, 2, 0, 41);
}
function TimeFieldContainer$_get_hourOfAmPm_$ref_okyxye() {
  return constructCallableReference((p0) => p0.get_hourOfAmPm_c9obsj_k$(), 1, 0, 42);
}
function TimeFieldContainer$_set_hourOfAmPm_$ref_y4i32() {
  return constructCallableReference((p0, p1) => {
    p0.set_hourOfAmPm_4kn0va_k$(p1);
    return Unit_instance;
  }, 2, 0, 43);
}
var TimeFieldsClass;
function TimeFields() {
  if (TimeFieldsClass === VOID) {
    class $ {
      constructor() {
        TimeFields_instance = this;
        var tmp = this;
        var tmp_0 = KMutableProperty1();
        var tmp_1 = TimeFieldContainer$_get_hour_$ref_8ezbwm();
        tmp.hour_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('hour', 1, tmp_0, tmp_1, TimeFieldContainer$_set_hour_$ref_l7vnde())), 0, 23);
        var tmp_2 = this;
        var tmp_3 = KMutableProperty1();
        var tmp_4 = TimeFieldContainer$_get_minute_$ref_evb2i2();
        tmp_2.minute_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('minute', 1, tmp_3, tmp_4, TimeFieldContainer$_set_minute_$ref_6xin6())), 0, 59);
        var tmp_5 = this;
        var tmp_6 = KMutableProperty1();
        var tmp_7 = TimeFieldContainer$_get_second_$ref_t7tjxy();
        tmp_5.second_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('second', 1, tmp_6, tmp_7, TimeFieldContainer$_set_second_$ref_qr1wvy())), 0, 59, VOID, 0);
        var tmp_8 = this;
        var tmp_9 = KMutableProperty1();
        var tmp_10 = TimeFieldContainer$_get_fractionOfSecond_$ref_u85by5();
        tmp_8.fractionOfSecond_1 = new (GenericFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('fractionOfSecond', 1, tmp_9, tmp_10, TimeFieldContainer$_set_fractionOfSecond_$ref_quw20n()), 'nanosecond'), VOID, new (DecimalFraction())(0, 9));
        var tmp_11 = this;
        var tmp_12 = KMutableProperty1();
        var tmp_13 = TimeFieldContainer$_get_amPm_$ref_u9tt1b();
        tmp_11.amPm_1 = new (GenericFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('amPm', 1, tmp_12, tmp_13, TimeFieldContainer$_set_amPm_$ref_hgxhkj())));
        var tmp_14 = this;
        var tmp_15 = KMutableProperty1();
        var tmp_16 = TimeFieldContainer$_get_hourOfAmPm_$ref_okyxye();
        tmp_14.hourOfAmPm_1 = new (UnsignedFieldSpec())(new (PropertyAccessor())(getPropertyCallableRef('hourOfAmPm', 1, tmp_15, tmp_16, TimeFieldContainer$_set_hourOfAmPm_$ref_y4i32())), 1, 12);
      }
    }
    initMetadataForObject($, 'TimeFields');
    TimeFieldsClass = $;
  }
  return TimeFieldsClass;
}
var TimeFields_instance;
function TimeFields_getInstance() {
  if (TimeFields_instance === VOID)
    new (TimeFields())();
  return TimeFields_instance;
}
function ISO_TIME$delegate$lambda() {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  var tmp = Companion_instance;
  return tmp.build_agwrib_k$(ISO_TIME$delegate$lambda$lambda);
}
function ISO_TIME$delegate$lambda$lambda($this$build) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  $this$build.hour$default_ke0z0o_k$();
  char($this$build, _Char___init__impl__6a9atx(58));
  $this$build.minute$default_r7oarc_k$();
  var tmp = [ISO_TIME$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_TIME$delegate$lambda$lambda$lambda_0);
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(58));
  $this$alternativeParsing.second$default_ix75t4_k$();
  optional($this$alternativeParsing, VOID, ISO_TIME$delegate$lambda$lambda$lambda$lambda);
  return Unit_instance;
}
function ISO_TIME$delegate$lambda$lambda$lambda$lambda($this$optional) {
  _init_properties_LocalTimeFormat_kt__5i3lfh();
  char($this$optional, _Char___init__impl__6a9atx(46));
  $this$optional.secondFraction_6m5e86_k$(1, 9);
  return Unit_instance;
}
function _get_ISO_TIME_$ref_kyx2od() {
  return constructCallableReference(() => get_ISO_TIME(), 0, 0, 44);
}
function AmPmMarker_AM_getInstance() {
  static_init();
  return AmPmMarker_AM_instance;
}
function AmPmMarker_PM_getInstance() {
  static_init();
  return AmPmMarker_PM_instance;
}
var properties_initialized_LocalTimeFormat_kt_l1b0w1;
function _init_properties_LocalTimeFormat_kt__5i3lfh() {
  if (!properties_initialized_LocalTimeFormat_kt_l1b0w1) {
    properties_initialized_LocalTimeFormat_kt_l1b0w1 = true;
    ISO_TIME$delegate = lazy(ISO_TIME$delegate$lambda);
    emptyIncompleteLocalTime = new (IncompleteLocalTime())();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstance2adk18we47186,
  Companion_instance as Companion_instance3or33wnaitl75,
  hour as hour31jxjrzfyqe0i,
  minute as minute2dqmds23fogn6,
  secondFraction as secondFraction17r4cie9ncxw,
  second as secondq4lhw2ppe1iv,
  time as time3kvfctmdykstm,
  AbstractWithTimeBuilder as AbstractWithTimeBuilder2vqnew72ok0ro,
  FractionalSecondDirective as FractionalSecondDirective1min2m2ag51uu,
  get_ISO_TIME as get_ISO_TIME31n00f6uljtbs,
  IncompleteLocalTime as IncompleteLocalTime3h4nusjwtlckd,
  TimeFieldContainer as TimeFieldContainer3bsvpq7sk70go,
};
//endregion

//# sourceMappingURL=LocalTimeFormat.mjs.map
